import { Link } from 'react-router-dom'
import { SeverityDonut } from '@/shared/components/SeverityDonut'
import { HelpIcon } from '@/shared/components/HelpIcon'
import type { TenantAnalytics } from '@/lib/apiTypes'
import { rowStyle } from '@/features/dashboard/cards/styles'

export function TopRiskModulesCard({ modules }: { modules: TenantAnalytics['top_risk_modules'] }) {
  return (
    <div className="card fu">
      <div className="card-header">
        <div>
          <div className="kicker">Risk</div>
          <h3 style={{ fontSize: '0.95rem' }}>Highest risk modules</h3>
        </div>
        <HelpIcon track="help_highest_risk_modules" title="Highest risk modules" kicker="// what this implies">
          <p>Module versions ranked by their count of unresolved
          <strong> critical</strong> and <strong>high</strong> scan findings.</p>
          <p>These are your triage targets: the published artefacts most likely to
          carry real risk into a consumer's infrastructure. Fix the findings and
          republish, or block the affected versions from consumption until they're
          remediated, so a known-bad module can't keep being pulled.</p>
        </HelpIcon>
      </div>
      {modules.map((m, i) => (
        <Link
          key={i}
          to={`/org/${m.namespace}/modules/${m.name}/${m.provider}/${m.version}`}
          style={rowStyle}
          onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--bg3)')}
          onMouseLeave={(e) => (e.currentTarget.style.background = '')}
        >
          <div>
            <div style={{ fontFamily: 'var(--mono)', fontSize: '0.8rem', color: 'var(--text)' }}>
              {m.name}
            </div>
            <div style={{ fontSize: '0.72rem', color: 'var(--text2)', marginTop: 2 }}>
              {m.provider} · v{m.version}
            </div>
          </div>
          {/* focusable={false}: the enclosing Link is the tab stop; the donut's aria-label
              already spells the counts out, so a second stop inside it would be a trap. */}
          <SeverityDonut
            critical={m.critical_count}
            high={m.high_count}
            total={m.critical_count + m.high_count}
            focusable={false}
          />
        </Link>
      ))}
    </div>
  )
}

